import React from 'react'
import { Heading } from '../ui'

interface DashboardSectionHeaderProps {
  icon: React.ReactNode
  title: string
  action?: React.ReactNode
  subtitle?: React.ReactNode
  compact?: boolean
}

const DashboardSectionHeader: React.FC<DashboardSectionHeaderProps> = ({
  icon,
  title,
  action,
  subtitle,
  compact = false,
}) => (
  <div
    className={`flex items-center justify-between ${compact ? 'gap-2 mb-2' : 'flex-col sm:flex-row gap-3 mb-4'}`}
  >
    <div className="flex flex-1 items-center gap-2 min-w-0">
      <span className="flex-shrink-0 text-primary-500">{icon}</span>
      <div className="min-w-0">
        <Heading
          as="h2"
          size={compact ? 'xl' : '2xl'}
          className="text-gray-900 dark:text-white truncate"
        >
          {title}
        </Heading>
        {subtitle}
      </div>
    </div>
    {action && <div className="flex-shrink-0">{action}</div>}
  </div>
)

export default DashboardSectionHeader
